var lodestarAppearances = new Set(["primary", "secondary", "destructive", "secondary-destructive", "borderless"]);
export var mapButtonAppearance = function mapButtonAppearance(appearance, themeMode) {
  var actualAppearance = appearance;

  // TODO delete this function and all usages in a major release.
  if (actualAppearance === "destructive-tertiary") {
    actualAppearance = "secondary-destructive";
  }
  if (themeMode === "ursa-light" && lodestarAppearances.has(actualAppearance)) {
    switch (actualAppearance) {
      case "primary":
        actualAppearance = "primary-filled";
        break;
      case "secondary":
        actualAppearance = "secondary-filled";
        break;
      case "destructive":
        actualAppearance = "destructive-filled";
        break;
      case "secondary-destructive":
        actualAppearance = "destructive-empty";
        break;
      case "borderless":
        actualAppearance = "primary-empty";
        break;
    }
  }
  return actualAppearance;
};
//# sourceMappingURL=mapButtonAppearance.js.map